import { defaultError } from "@-/com.npmjs.react-context-default-error";
import { createContext, useContext } from "react";

export interface ToolbarPopoverContextValue {
  /**
   * Collapses the popover back into its pill. The modal and the popover's content unmount in the
   * same commit; the collapse is drawn afterwards at the pill, below anything presented since. So
   * run an action beside `close()`, never deferred until after it: a sheet, dialog or route it
   * presents lands on top. Own what it presents outside the popover's content, which is gone
   * once the popover closes.
   */
  close: () => void;
  isOpen: boolean;
}

export const ToolbarPopoverContext = createContext<ToolbarPopoverContextValue>(
  defaultError<ToolbarPopoverContextValue>("ToolbarPopoverContext"),
);

/** The enclosing `ToolbarPopoverButton`'s controls, for content that closes itself. */
export function useToolbarPopover(): ToolbarPopoverContextValue {
  return useContext(ToolbarPopoverContext);
}
